




































































































import { ApiClient } from "@/api/client";
import { Banktransfer, PaymentResponse } from "@/interfaces/purchase";
import { Component } from "vue-property-decorator";
import { UserAccount } from "@/interfaces/user";
import { mapState } from "vuex";

import Vue from "vue";
import i18n from "@/i18n";

interface PaymentMethod {
  name: string;
  label: string;
  icon: string;
  note: string;
}

interface ChargeAction {
  amount: number;
  coins: number;
  provider: string;
}

interface ChargeActions {
  paysafecard: ChargeAction[];
  banktransfer: ChargeAction[];
}

@Component({
  computed: {
    ...mapState(["user"])
  }
})
export default class ChargeAccount extends Vue {
  // Mapped from vuex
  user!: UserAccount;

  // Other variables
  api: ApiClient = new ApiClient();
  openBanktransfers: Banktransfer[] = [];

  get userShortId(): number {
    return this.user.short_id;
  }

  async mounted() {
    this.openBanktransfers = await this.api.getOpenBanktransfers();
  }

  paymentMethods: PaymentMethod[] = [
    {
      name: "paysafecard",
      label: "paysafecard",
      icon: "credit-card",
      note: i18n.t("views.charge.pscDisclaimer") as string
    },
    {
      name: "banktransfer",
      label: "Banküberweisung",
      icon: "university",
      note: ""
    }
  ];

  actions: ChargeActions = {
    paysafecard: [
      {
        amount: 1,
        coins: 100,
        provider: "paysafecard"
      },
      {
        amount: 10,
        coins: 1000,
        provider: "paysafecard"
      },
      {
        amount: 20,
        coins: 2200,
        provider: "paysafecard"
      },
      {
        amount: 50,
        coins: 6000,
        provider: "paysafecard"
      }
    ],
    banktransfer: [
      {
        amount: 5,
        coins: 500,
        provider: "banktransfer"
      },
      {
        amount: 10,
        coins: 1000,
        provider: "banktransfer"
      },
      {
        amount: 20,
        coins: 2200,
        provider: "banktransfer"
      },
      {
        amount: 50,
        coins: 6000,
        provider: "banktransfer"
      }
    ]
  };

  async purchase(action: ChargeAction) {
    const response = await this.api.initiatePayment(
      action.provider,
      action.amount.toString(),
      action.amount,
      action.coins,
      window.location.href
    );

    console.log(response);

    if (response.payment_type === "paysafecard") {
      const pscResponse = (response as unknown) as PaymentResponse;
      if (pscResponse.ok && pscResponse.url) {
        window.location.href = pscResponse.url;
      }
    } else if (response.payment_type === "banktransfer") {
      const bankResponse = (response as unknown) as Banktransfer;
      this.openBanktransfers.push(bankResponse);
    }
  }

  async cancelTransfer(id: string) {
    this.openBanktransfers = await this.api.cancelOpenBanktransfers(id);
  }
}
